export default __webpack_public_path__ + "static/media/contact.13b54b0b.png";